import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submit", "ticketSelect"]
  static values = { minTicketCount: { type: Number, default: 1 } }

  connect() {
    this.validateForm()
  }

  validateForm() {
    const isPolicyChecked = this.hasCheckboxTarget ? this.checkboxTarget.checked : true
    const hasTickets = this.hasEnoughTickets()

    this.submitTarget.disabled = !(isPolicyChecked && hasTickets)
  }

  // At least one ticket, or the schedule's private minimum when it has one.
  hasEnoughTickets() {
    const total = this.ticketSelectTargets.reduce((sum, select) => sum + (parseInt(select.value, 10) || 0), 0)
    return total >= Math.max(this.minTicketCountValue, 1)
  }
}
